<!--
 * @Description: 成分股排行
 * @Author: aihh
 * @Date: 2019-09-03
 * @LastEditTime: 2019-09-03
 * @LastEditors: aihh
 -->
<template>
  <div class="box">
    <ul class="tab-header">
      <li>Shares</li>
      <li>Latest price(yuan)</li>
      <li>Up and down range</li>
    </ul>
    <div style="flex: 1;overflow-y: auto;width: 100%" class="innerbox scroll_bar_wzj">
      <ul v-for="(item,index) in sortData" :key="item.name" style="line-height:32px" @click="getCodeInfo(item,index)">
<!--        {{item}}-->
        <li>{{item["prod_name"]}}</li>
        <!-- 最新价 -->
        <li v-if="item.last_px===0">
          <span
           v-if="item.last_px"
           :class="[
            {'bg-red':item.last_px_wzjChange==1},
            {'bg-green':item.last_px_wzjChange==2},
            {'bg-none':item.last_px_wzjChange==0}
           ]"
          >
            {{item["last_px"].toFixed(getToFixed(prod_code,'price'))}}
          </span>
          <span v-else>
            --
          </span>
        </li>
        <li v-else :style="{color:item.last_px>0?'#EF4342':'#2AB447'}">
          <span :class="[
            {'bg-red':item.last_px_wzjChange==1},
            {'bg-green':item.last_px_wzjChange==2},
            {'bg-none':item.last_px_wzjChange==0}
           ]">
            {{item["last_px"].toFixed(getToFixed(prod_code,'price'))}}
          </span>
        </li>
        <!-- 涨跌幅 -->
       <li v-if="item.px_change_rate===0">
          <span
          v-if="item.last_px"
          :class="[
            {'bg-red':item.px_change_rate_wzjChange==1},
            {'bg-green':item.px_change_rate_wzjChange==2},
            {'bg-none':item.px_change_rate_wzjChange==0}
           ]">
            {{item["px_change_rate"].toFixed(getToFixed(prod_code,'price'))}}%
          </span>
          <span v-else>
            --
          </span>
        </li>
        <li v-else :style="{color:item.px_change_rate>0?'#EF4342':'#2AB447'}">
          <span :class="[
            {'bg-red':item.px_change_rate_wzjChange==1},
            {'bg-green':item.px_change_rate_wzjChange==2},
            {'bg-none':item.px_change_rate_wzjChange==0}
           ]">
            {{item["px_change_rate"].toFixed(2)}}%
          </span>
        </li>

<!--        <li v-if="item[5]===0">{{item[3]}}</li>-->
<!--        <li v-else :style="{color:item[5]<0?'#2AB447':'#EF4342'}">{{item[3].toFixed(2)}}</li>-->
<!--        <li v-if="item[5]===0">{{item[5].toFixed(2)}}%</li>-->
<!--        <li v-else :style="{color:item[5]<0?'#2AB447':'#EF4342'}">{{item[5]<0?'-':''}}{{Math.abs(item[4]).toFixed(2)}}%</li>-->
      </ul>
    </div>
    <div style="height: 1px;"></div>
  </div>
</template>

<script>
import { checkExchange,getToFixed } from '../../controller/util.js'
import { OpenAPI } from '../../controller/datamanager/api.js'
// let API = new OpenAPI()
export default {
  name: 'constituentsRank',
  props: {
    prod_code: {
      type: String,
      default: ''
    },
    throttle: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      // 定时器
      timer: null,
      sortData: [],
      getToFixed:getToFixed
    }
  },
  created() {
    this.getSortDataInterval(this.prod_code, 'prod_name,last_px,px_change_rate')
    // 轮询
       if(this.throttle > 0){
         this.timer = setInterval(()=>{
              this.getSortDataInterval(this.prod_code, 'prod_name,last_px,px_change_rate')
         },10000)
       }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
      getCodeInfo(value,code){
          const obj={
              code:value.prod_code,name:value.prod_name
          }
          this.$emit('clickProd',obj)
      },
    getSortDataInterval(code, fields){
      let params = {code, fields}
      OpenAPI.blockSort(params).then(res => {
        if(res.data && res.data.sort){
          let ss = res.data.sort;
          let fields = ss.fields;
          let showData = [];
          for (let a in ss) {
            if ("fields" === a) {
              continue;
            }
          var tmp = {};
          // 代码
          tmp["prod_code"] = a
          // 名称
          tmp["prod_name"] = ss[a][fields.indexOf("prod_name")];
          // 最新价
          tmp["last_px"] = ss[a][fields.indexOf("last_px")];
          // 涨跌幅
          tmp["px_change_rate"] = ss[a][fields.indexOf("px_change_rate")];
          showData.push(tmp);
          }
          // 添加背景颜色
          showData.forEach( newVal => {
          	this.sortData.forEach(oldVal => {
          		if(newVal.prod_name === oldVal.prod_name){
          			 for(let key in newVal) {
                  // 变化项处理
                  if(typeof newVal[key] === 'number'){
                  	if(newVal[key] > oldVal[key]){
                      let newKey = `${key}_wzjChange`
                      newVal[newKey] = 1
                  	}else if(newVal[key] < oldVal[key]){
                      let newKey = `${key}_wzjChange`
                      newVal[newKey] = 2
                  	}else{
                      let newKey = `${key}_wzjChange`
                      newVal[newKey] = 0
                  	}
                  }
          			 }
          		}
          	})
          })
          // console.log(this.sortData)
          this.sortData = showData
        }
        }).catch(err => {
          // return alert('请检查成分股代码格式！')
          console.log('请检查成分股代码格式！')
        })

    }
  },
}
</script>

<style scoped lang="scss">
*{
  padding: 0;
  margin: 0;
  font-size: 14px;
  list-style-type: none;
  text-align: center;
  box-sizing: border-box;
}
.bg-red {
  /* background: #F9D9E4; */
  background: rgb(255,253,215);
}
.bg-green {
  /* background: #D3F5D4; */
  background: rgb(255,253,215);
}
.tab-header{
  height: 40px;
  color: #399BFF;
  width: 98%;
  margin-right: 6px;
}
.box{
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.innerbox ul>li:nth-child(1) {
  cursor: pointer;
}
.innerbox ul:hover {
  background: #E4EDF3;
}
.innerbox ul:hover li span{
  background: #E4EDF3;
}
.innerbox::-webkit-scrollbar {width: 6px;}
.innerbox::-webkit-scrollbar-thumb {border-radius: 4px;-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);background: rgba(193,193,193,193);}
.innerbox::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}
.scroll_bar_wzj {
    height: 100%;
    overflow: hidden;

  }
/*Edge*/
@supports (-ms-ime-align:auto) {
			.scroll_bar_wzj {
        box-sizing: content-box;
				margin-right: -10px;
        padding-right: 10px;
        li{
          &:nth-child(2){
            span{
              margin-right: -7px;
            }
          }
          &:nth-child(3){
            span{
              margin-right: -10px;
            }
          }
        }
			}
			.scroll_bar_wzj:after {
				content: "";
				height: 16px;
				display: block;
			}
		}

ul{
  padding: 0 15px;

  min-height: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  color: #333;
  li{
    text-align: right;
    span{
      display: inline-block;
      text-align: right;
      width: 65px;
      line-height: 24px;
    }
    &:nth-child(1){
      text-align: left;
      width: 30%;
    }
    &:nth-child(2){
      width: 31%;
    }
    &:nth-child(3){
      width: 39%;
    }
  }
}
</style>
